import React from 'react';
import RatingPositiveIcon from '@tradera/blueprint/theme/icons2/rating-positive.svg?jsx';
import RatingNegativeIcon from '@tradera/blueprint/theme/icons2/rating-negative.svg?jsx';

const nonActiveButtonClasses = 'btn btn-light btn-lg btn-round border';
const activeButtonClasses = 'btn btn-lg btn-round';

const _Happy = ({ active, className = '', onClick }) => (
    <button
        type="button"
        className={`${active ? activeButtonClasses : nonActiveButtonClasses} ${
            active ? 'btn-success' : 'text-success'
        } ${className}`}
        onClick={onClick}>
        <RatingPositiveIcon className={`icon icon-lg`} />
    </button>
);

const _Sad = ({ active, className = '', onClick }) => (
    <button
        type="button"
        className={`btn ${
            active ? activeButtonClasses : nonActiveButtonClasses
        } ${active ? 'btn-outline-danger' : 'text-danger'} ${className}`}
        onClick={onClick}>
        <RatingNegativeIcon className={`icon icon-lg`} />
    </button>
);

export const Happy = React.memo(_Happy);
export const Sad = React.memo(_Sad);
